import { Construtor } from './construtor';
import { Setor } from './setor';

export class SetorCliente implements Construtor<SetorCliente> {

  public idSetorCliente: number;
  public idCliente: number;
  public setor: Setor;
  public pontosFisicosVinculados: number;
  public selecionado: boolean;
  public alterado: boolean;

  constructor(object?: any) {
    this.setor = new Setor();
    if (object !== undefined) {
      if (object instanceof (SetorCliente)) {
        this.copyObject(object);
      } else if (object instanceof Setor) {
        this.setor = new Setor(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  set IdSetorCliente(idSetorCliente: any) {
    this.idSetorCliente = idSetorCliente;
  }

  set Setor(setor: any) {
    this.setor = setor;
  }

  set IdCliente(idCliente: any) {
    this.idCliente = idCliente;
  }

  parseFromJson(setorCliente: any): void {
    this.idSetorCliente = setorCliente.idSetorCliente;
    this.setor = setorCliente.setor;
    this.pontosFisicosVinculados = setorCliente.pontosFisicosVinculados;
    this.idCliente = setorCliente.idCliente;
  }

  copyObject(setorCliente: SetorCliente): void {
    this.idSetorCliente = setorCliente.idSetorCliente;
    this.setor = setorCliente.setor;
    this.pontosFisicosVinculados = setorCliente.pontosFisicosVinculados;
    this.idCliente = setorCliente.idCliente;
  }

  modeloCompleto(): boolean {
    return this.setor !== undefined && this.idCliente !== undefined;
  }

  getNewInstance(object?: any): SetorCliente {
    return new SetorCliente(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/setor-cliente.ts